// extracted by mini-css-extract-plugin
export default {"button":"Button_button__QcW-M","disabled":"Button_disabled__m3sg+","bck":"Button_bck__pHcse"};